import * as yup from 'yup'

export const updateDocumentSchema = (t: any, hasExpired: boolean) =>
    yup.object().shape({
        name_file: yup.string().required(t('documents.schema.name_file')),
        descriptions: yup.string().required(t('documents.schema.descriptions')),
        document_type: yup
            .string()
            .required(t('documents.schema.document_type')),
        document_level: yup
            .string()
            .required(t('documents.schema.document_level')),
        department_id: yup
            .number()
            .required(t('documents.schema.department_id')),
        start_day: yup.date().required(t('documents.schema.start_day')),
        end_day: hasExpired
            ? yup.date().required(t('documents.schema.end_day'))
            : yup.date().notRequired(),

        departments: yup
            .array()
            .of(yup.number().required())
            .when('sharing_enable', {
                is: true,
                then: (schema) => schema,
                otherwise: (schema) => schema.notRequired(),
            }),
        employees: yup
            .array()
            .of(yup.number().required())
            .when('sharing_enable', {
                is: true,
                then: (schema) => schema,
                otherwise: (schema) => schema.notRequired(),
            }),
    })
